const US_STATE_META = [
  { id: "alabama", abbr: "al", name: "Alabama" },
  { id: "alaska", abbr: "ak", name: "Alaska" },
  { id: "arizona", abbr: "az", name: "Arizona" },
  { id: "arkansas", abbr: "ar", name: "Arkansas" },
  { id: "california", abbr: "ca", name: "California" },
  { id: "colorado", abbr: "co", name: "Colorado" },
  { id: "connecticut", abbr: "ct", name: "Connecticut" },
  { id: "delaware", abbr: "de", name: "Delaware" },
  { id: "district-of-columbia", abbr: "dc", name: "District of Columbia" },
  { id: "florida", abbr: "fl", name: "Florida" },
  { id: "georgia", abbr: "ga", name: "Georgia" },
  { id: "hawaii", abbr: "hi", name: "Hawaii" },
  { id: "idaho", abbr: "id", name: "Idaho" },
  { id: "illinois", abbr: "il", name: "Illinois" },
  { id: "indiana", abbr: "in", name: "Indiana" },
  { id: "iowa", abbr: "ia", name: "Iowa" },
  { id: "kansas", abbr: "ks", name: "Kansas" },
  { id: "kentucky", abbr: "ky", name: "Kentucky" },
  { id: "louisiana", abbr: "la", name: "Louisiana" },
  { id: "maine", abbr: "me", name: "Maine" },
  { id: "maryland", abbr: "md", name: "Maryland" },
  { id: "massachusetts", abbr: "ma", name: "Massachusetts" },
  { id: "michigan", abbr: "mi", name: "Michigan" },
  { id: "minnesota", abbr: "mn", name: "Minnesota" },
  { id: "mississippi", abbr: "ms", name: "Mississippi" },
  { id: "missouri", abbr: "mo", name: "Missouri" },
  { id: "montana", abbr: "mt", name: "Montana" },
  { id: "nebraska", abbr: "ne", name: "Nebraska" },
  { id: "nevada", abbr: "nv", name: "Nevada" },
  { id: "new-hampshire", abbr: "nh", name: "New Hampshire" },
  { id: "new-jersey", abbr: "nj", name: "New Jersey" },
  { id: "new-mexico", abbr: "nm", name: "New Mexico" },
  { id: "new-york", abbr: "ny", name: "New York" },
  { id: "north-carolina", abbr: "nc", name: "North Carolina" },
  { id: "north-dakota", abbr: "nd", name: "North Dakota" },
  { id: "ohio", abbr: "oh", name: "Ohio" },
  { id: "oklahoma", abbr: "ok", name: "Oklahoma" },
  { id: "oregon", abbr: "or", name: "Oregon" },
  { id: "pennsylvania", abbr: "pa", name: "Pennsylvania" },
  { id: "rhode-island", abbr: "ri", name: "Rhode Island" },
  { id: "south-carolina", abbr: "sc", name: "South Carolina" },
  { id: "south-dakota", abbr: "sd", name: "South Dakota" },
  { id: "tennessee", abbr: "tn", name: "Tennessee" },
  { id: "texas", abbr: "tx", name: "Texas" },
  { id: "utah", abbr: "ut", name: "Utah" },
  { id: "vermont", abbr: "vt", name: "Vermont" },
  { id: "virginia", abbr: "va", name: "Virginia" },
  { id: "washington", abbr: "wa", name: "Washington" },
  { id: "west-virginia", abbr: "wv", name: "West Virginia" },
  { id: "wisconsin", abbr: "wi", name: "Wisconsin" },
  { id: "wyoming", abbr: "wy", name: "Wyoming" }
];

const ABBR_TO_STATE_ID = new Map(US_STATE_META.map((state) => [state.abbr, state.id]));
const STATE_ID_TO_META = new Map(US_STATE_META.map((state) => [state.id, state]));
const STATE_LABEL_OVERRIDES = {
  connecticut: { dx: 22, dy: 8, anchor: "start" },
  delaware: { dx: 18, dy: 16, anchor: "start" },
  "district-of-columbia": { dx: 18, dy: 30, anchor: "start" },
  maryland: { dx: 18, dy: 23, anchor: "start" },
  massachusetts: { dx: 28, dy: -10, anchor: "start" },
  "new-hampshire": { dx: 20, dy: -18, anchor: "start" },
  "new-jersey": { dx: 24, dy: 5, anchor: "start" },
  "rhode-island": { dx: 24, dy: 4, anchor: "start" },
  vermont: { dx: 8, dy: -18, anchor: "middle" }
};

function escapeHtml(value) {
  return String(value || "")
    .replaceAll("&", "&amp;")
    .replaceAll("<", "&lt;")
    .replaceAll(">", "&gt;")
    .replaceAll('"', "&quot;")
    .replaceAll("'", "&#39;");
}

if (!customElements.get("m-service-area-map")) {
  class MServiceAreaMap extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;

      this.svgStageEl = this.querySelector("[data-svg-stage]");
      this.statusEl = this.querySelector("[data-map-status]");
      this.mobileHintEl = this.querySelector("[data-mobile-swipe-hint]");
      this.inlineDataEl = this.querySelector("[data-service-area-block-data]");
      this.layoutEl = this.querySelector(".m-service-area-map__layout");
      this.resetButtons = Array.from(this.querySelectorAll("[data-reset-map]"));
      this.expandButtons = Array.from(this.querySelectorAll("[data-toggle-expand]"));
      this.closeExpandButtons = Array.from(this.querySelectorAll("[data-close-expand]"));
      this.expandBackdropEl = this.querySelector("[data-expand-backdrop]");
      this.badgeEl = this.querySelector("[data-state-badge]");
      this.titleEl = this.querySelector("[data-state-title]");
      this.labelEl = this.querySelector("[data-state-label]");
      this.descriptionEl = this.querySelector("[data-state-description]");
      this.actionsEl = this.querySelector("[data-state-actions]");
      this.cityZoneEl = this.querySelector("[data-city-zone]");
      this.cityTitleEl = this.querySelector("[data-city-title]");
      this.citySubtextEl = this.querySelector("[data-city-subtext]");
      this.cityPillsEl = this.querySelector("[data-city-pills]");
      this.cityCardEl = this.querySelector("[data-city-card]");
      this.cityBadgeEl = this.querySelector("[data-city-badge]");
      this.cityNameEl = this.querySelector("[data-city-name]");
      this.cityStateEl = this.querySelector("[data-city-state]");
      this.cityServiceLabelEl = this.querySelector("[data-city-service-label]");
      this.cityDescriptionEl = this.querySelector("[data-city-description]");
      this.cityMetaEl = this.querySelector("[data-city-meta]");
      this.cityActionsEl = this.querySelector("[data-city-actions]");
      this.emptyEl = this.querySelector("[data-empty-state]");

      this.activeState = null;
      this.activeCity = null;
      this.isExpanded = false;
      this.isDraggingMap = false;
      this.hasDraggedMap = false;
      this.suppressMapClick = false;
      this.dragPointerId = null;
      this.dragStartX = 0;
      this.dragStartY = 0;
      this.dragScrollLeft = 0;
      this.dragScrollTop = 0;
      this.data = null;
      this.svgEl = null;
      this.stateNodes = new Map();
      this.stateLabels = new Map();
      this.stateLeaderLines = new Map();
      this.defaultSummary = {
        badge: this.badgeEl?.textContent?.trim() || this.dataset.nationalBadge || "",
        title: this.titleEl?.textContent?.trim() || this.dataset.nationalHeading || "Nationwide hibachi inquiries",
        label: this.labelEl?.textContent?.trim() || this.dataset.nationalBadge || "",
        descriptionHtml: this.descriptionEl?.innerHTML || ""
      };
      this.defaultCityContent = {
        title: this.cityTitleEl?.textContent?.trim() || "Featured cities",
        subtext:
          this.citySubtextEl?.textContent?.trim() ||
          "Choose a city to reveal its service focus and booking link."
      };

      this.addEventListener("click", this.handleClick);
      this.addEventListener("keydown", this.handleKeydown);
      this.svgStageEl?.addEventListener("scroll", this.handleMapScroll, { passive: true });
      this.svgStageEl?.addEventListener("pointerdown", this.handleMapPointerDown);
      this.svgStageEl?.addEventListener("pointermove", this.handleMapPointerMove);
      this.svgStageEl?.addEventListener("pointerup", this.handleMapPointerUp);
      this.svgStageEl?.addEventListener("pointercancel", this.handleMapPointerUp);
      this.svgStageEl?.addEventListener("pointerleave", this.handleMapPointerUp);
      document.addEventListener("keydown", this.handleDocumentKeydown);
      this.loadData();
    }

    disconnectedCallback() {
      this.removeEventListener("click", this.handleClick);
      this.removeEventListener("keydown", this.handleKeydown);
      this.svgStageEl?.removeEventListener("scroll", this.handleMapScroll);
      this.svgStageEl?.removeEventListener("pointerdown", this.handleMapPointerDown);
      this.svgStageEl?.removeEventListener("pointermove", this.handleMapPointerMove);
      this.svgStageEl?.removeEventListener("pointerup", this.handleMapPointerUp);
      this.svgStageEl?.removeEventListener("pointercancel", this.handleMapPointerUp);
      this.svgStageEl?.removeEventListener("pointerleave", this.handleMapPointerUp);
      document.removeEventListener("keydown", this.handleDocumentKeydown);
      this.toggleExpanded(false);
    }

    handleClick = (event) => {
      if (this.suppressMapClick) {
        this.suppressMapClick = false;
        event.preventDefault();
        event.stopPropagation();
        return;
      }

      const stateButton = event.target.closest("[data-state-id]");
      if (stateButton) {
        this.selectState(stateButton.dataset.stateId);
        return;
      }

      const cityButton = event.target.closest("[data-city-id]");
      if (cityButton) {
        this.selectCity(cityButton.dataset.cityId);
        return;
      }

      const expandButton = event.target.closest("[data-toggle-expand]");
      if (expandButton) {
        this.toggleExpanded();
        return;
      }

      const closeExpandButton = event.target.closest("[data-close-expand]");
      if (closeExpandButton) {
        this.toggleExpanded(false);
        return;
      }

      const expandBackdrop = event.target.closest("[data-expand-backdrop]");
      if (expandBackdrop) {
        this.toggleExpanded(false);
        return;
      }

    };

    handleKeydown = (event) => {
      const stateTarget = event.target.closest(".m-service-area-map__state-shape[data-state-id]");
      if (!stateTarget) return;

      if (event.key === "Enter" || event.key === " ") {
        event.preventDefault();
        this.selectState(stateTarget.dataset.stateId);
      }
    };

    handleDocumentKeydown = (event) => {
      if (event.key === "Escape" && this.isExpanded) {
        this.toggleExpanded(false);
      }
    };

    handleMapScroll = () => {
      this.updateSwipeHint();
    };

    handleMapPointerDown = (event) => {
      if (!this.canDragMap()) return;
      if (event.pointerType === "mouse" && event.button !== 0) return;

      this.isDraggingMap = true;
      this.hasDraggedMap = false;
      this.dragPointerId = event.pointerId;
      this.dragStartX = event.clientX;
      this.dragStartY = event.clientY;
      this.dragScrollLeft = this.svgStageEl.scrollLeft;
      this.dragScrollTop = this.svgStageEl.scrollTop;

      this.svgStageEl.setPointerCapture?.(event.pointerId);
      this.svgStageEl.classList.add("is-drag-ready");
    };

    handleMapPointerMove = (event) => {
      if (!this.isDraggingMap || this.dragPointerId !== event.pointerId || !this.svgStageEl) return;

      const deltaX = event.clientX - this.dragStartX;
      const deltaY = event.clientY - this.dragStartY;
      if (!this.hasDraggedMap && Math.abs(deltaX) < 6 && Math.abs(deltaY) < 6) return;

      this.hasDraggedMap = true;
      this.svgStageEl.classList.add("is-dragging");
      this.svgStageEl.scrollLeft = this.dragScrollLeft - deltaX;
      this.svgStageEl.scrollTop = this.dragScrollTop - deltaY;
      this.updateSwipeHint();
      event.preventDefault();
    };

    handleMapPointerUp = (event) => {
      if (!this.isDraggingMap || this.dragPointerId !== event.pointerId) return;

      this.svgStageEl?.releasePointerCapture?.(event.pointerId);
      this.svgStageEl?.classList.remove("is-drag-ready", "is-dragging");
      this.isDraggingMap = false;
      this.dragPointerId = null;

      if (this.hasDraggedMap) {
        this.suppressMapClick = true;
        window.setTimeout(() => {
          this.suppressMapClick = false;
        }, 80);
      }
    };

    async loadData() {
      try {
        const inlineData = this.getInlineData();
        const mapResponse = await fetch(this.dataset.mapAsset, { credentials: "same-origin" });
        if (!mapResponse.ok) throw new Error("Failed to fetch");
        this.data = inlineData?.cities?.length ? this.normalizeBlockData(inlineData) : await this.fetchRemoteData();
        const svgText = await mapResponse.text();
        this.renderMap(svgText);
        if (this.isNationwideMode()) {
          this.selectOverview();
        } else {
          this.selectState(this.getDefaultStateId(), { isDefault: true });
        }
        this.setStatus("");
      } catch (error) {
        console.error("Service area map failed to initialize", error);
        this.setStatus("The U.S. service area data could not load. The nationwide inquiry flow is still available.");
      }
    }

    async fetchRemoteData() {
      const dataResponse = await fetch(this.dataset.source, { credentials: "same-origin" });
      if (!dataResponse.ok) throw new Error("Failed to fetch");
      return dataResponse.json();
    }

    getInlineData() {
      if (!this.inlineDataEl) return null;

      try {
        const data = JSON.parse(this.inlineDataEl.textContent || "{}");
        if (!Array.isArray(data.cities) || !data.cities.length) return null;
        return data;
      } catch (error) {
        console.error("Service area map block data is invalid", error);
        return null;
      }
    }

    isNationwideMode() {
      return this.dataset.nationwideMode === "true";
    }

    normalizeBlockData(rawData) {
      const normalized = {
        defaultState: (rawData.defaultState || this.dataset.defaultState || "florida").toLowerCase(),
        states: {}
      };

      (rawData.cities || []).forEach((entry) => {
        const stateId = String(entry.stateId || entry.stateName || "").trim().toLowerCase();
        const cityId = String(entry.cityId || entry.cityName || "").trim().toLowerCase();
        if (!stateId || !cityId) return;

        if (!normalized.states[stateId]) {
          normalized.states[stateId] = {
            name: entry.stateName || STATE_ID_TO_META.get(stateId)?.name || "United States",
            code: (entry.stateCode || STATE_ID_TO_META.get(stateId)?.abbr || "").toUpperCase(),
            badge: entry.stateBadge || "",
            badgeBgColor: entry.stateBadgeBgColor || "",
            badgeTextColor: entry.stateBadgeTextColor || "",
            label: entry.stateLabel || "",
            descriptionHtml: entry.stateDescriptionHtml || "",
            ctaLabel: entry.stateCtaLabel || "",
            ctaUrl: entry.stateCtaUrl || "",
            secondaryCtaLabel: entry.stateSecondaryCtaLabel || "",
            secondaryCtaUrl: entry.stateSecondaryCtaUrl || "",
            cities: []
          };
        }

        const state = normalized.states[stateId];
        if (!state.name && entry.stateName) state.name = entry.stateName;
        if (!state.code && entry.stateCode) state.code = String(entry.stateCode).toUpperCase();
        if (!state.badge && entry.stateBadge) state.badge = entry.stateBadge;
        if (!state.badgeBgColor && entry.stateBadgeBgColor) state.badgeBgColor = entry.stateBadgeBgColor;
        if (!state.badgeTextColor && entry.stateBadgeTextColor) state.badgeTextColor = entry.stateBadgeTextColor;
        if (!state.label && entry.stateLabel) state.label = entry.stateLabel;
        if (!state.descriptionHtml && entry.stateDescriptionHtml) state.descriptionHtml = entry.stateDescriptionHtml;
        if (!state.ctaLabel && entry.stateCtaLabel) state.ctaLabel = entry.stateCtaLabel;
        if (!state.ctaUrl && entry.stateCtaUrl) state.ctaUrl = entry.stateCtaUrl;
        if (!state.secondaryCtaLabel && entry.stateSecondaryCtaLabel) state.secondaryCtaLabel = entry.stateSecondaryCtaLabel;
        if (!state.secondaryCtaUrl && entry.stateSecondaryCtaUrl) state.secondaryCtaUrl = entry.stateSecondaryCtaUrl;

        state.cities.push({
          id: cityId,
          name: entry.cityName || cityId,
          badge: entry.cityBadge || "",
          accentBgColor: entry.cityAccentBgColor || "",
          accentTextColor: entry.cityAccentTextColor || "",
          serviceLabel: entry.cityServiceLabel || "",
          description: entry.cityDescriptionHtml || "",
          eventFocus: entry.cityEventFocus || "",
          travelNote: entry.cityTravelNote || "",
          ctaLabel: entry.cityCtaLabel || "",
          url: entry.cityUrl || "",
          secondaryLabel: entry.citySecondaryLabel || "",
          secondaryUrl: entry.citySecondaryUrl || ""
        });
      });

      return normalized;
    }

    getDefaultStateId() {
      const requestedId = (this.dataset.defaultState || this.data?.defaultState || "florida").toLowerCase();
      if (this.getStateData(requestedId) || STATE_ID_TO_META.has(requestedId)) {
        return requestedId;
      }

      const firstConfiguredState = Object.keys(this.data?.states || {})[0];
      if (firstConfiguredState) return firstConfiguredState;

      return "florida";
    }

    getStateData(stateId) {
      return this.data?.states?.[stateId] || null;
    }

    getOverviewState() {
      return {
        name: this.defaultSummary.title,
        badge: this.defaultSummary.badge,
        label: this.defaultSummary.label,
        descriptionHtml: this.defaultSummary.descriptionHtml,
        ctaLabel: this.dataset.nationalCtaLabel || "",
        ctaUrl: this.dataset.nationalCtaUrl || "",
        secondaryCtaLabel: this.dataset.secondaryCtaLabel || "",
        secondaryCtaUrl: this.dataset.secondaryCtaUrl || "",
        emailCtaLabel: this.dataset.emailCtaLabel || "",
        emailCtaUrl: this.dataset.emailCtaUrl || "",
        cities: []
      };
    }

    getFallbackState(stateId) {
      const gridState = STATE_ID_TO_META.get(stateId);
      return {
        name: gridState?.name || this.defaultSummary.title,
        code: gridState?.abbr?.toUpperCase() || "",
        badge: this.dataset.nationalBadge || "Available nationwide by inquiry",
        badgeBgColor: "",
        badgeTextColor: "",
        label: this.dataset.nationalBadge || "Available nationwide by inquiry",
        descriptionHtml: this.defaultSummary.descriptionHtml,
        ctaLabel: this.dataset.nationalCtaLabel || "Book nationwide inquiry",
        ctaUrl: this.dataset.nationalCtaUrl || "#",
        secondaryCtaLabel: this.dataset.secondaryCtaLabel || "",
        secondaryCtaUrl: this.dataset.secondaryCtaUrl || "",
        emailCtaLabel: this.dataset.emailCtaLabel || "",
        emailCtaUrl: this.dataset.emailCtaUrl || "",
        cities: []
      };
    }

    renderMap(svgText) {
      if (!this.svgStageEl) return;

      const parser = new DOMParser();
      const doc = parser.parseFromString(svgText, "image/svg+xml");
      const svg = doc.querySelector("svg");
      if (!svg) throw new Error("SVG map missing");

      svg.classList.add("m-service-area-map__svg");
      svg.setAttribute("role", "img");
      svg.setAttribute("aria-label", "United States service area map");

      this.stateNodes.clear();
      this.stateLabels.clear();
      this.stateLeaderLines.clear();
      svg.querySelectorAll("path[id]").forEach((path) => {
        const stateId = ABBR_TO_STATE_ID.get(path.id.toLowerCase());
        if (!stateId) return;

        const meta = STATE_ID_TO_META.get(stateId);
        const featuredState = this.getStateData(stateId);

        path.dataset.stateId = stateId;
        path.classList.add("m-service-area-map__state-shape");
        path.setAttribute("tabindex", "0");
        path.setAttribute("role", "button");
        path.setAttribute("aria-pressed", "false");
        path.setAttribute("aria-label", meta?.name || stateId);

        if (this.isNationwideMode()) {
          path.classList.add("is-nationwide");
        } else if (featuredState) {
          path.classList.add("is-featured");
        }

        const title = doc.createElementNS("http://www.w3.org/2000/svg", "title");
        title.textContent = meta?.name || stateId;
        path.prepend(title);

        this.stateNodes.set(stateId, path);
      });

      this.svgStageEl.innerHTML = "";
      this.svgStageEl.appendChild(svg);
      this.svgEl = svg;
      this.renderStateLabels(svg.ownerDocument, svg);
      this.updateSwipeHint();
    }

    renderStateLabels(doc, svg) {
      const ns = "http://www.w3.org/2000/svg";
      const labelLayer = doc.createElementNS(ns, "g");
      labelLayer.classList.add("m-service-area-map__label-layer");

      this.stateNodes.forEach((path, stateId) => {
        const meta = STATE_ID_TO_META.get(stateId);
        if (!meta) return;

        const bbox = path.getBBox();
        const centerX = bbox.x + bbox.width / 2;
        const centerY = bbox.y + bbox.height / 2;
        const override = STATE_LABEL_OVERRIDES[stateId];
        const tinyState = bbox.width < 18 || bbox.height < 14;

        let x = centerX;
        let y = centerY;
        let anchor = "middle";

        if (override) {
          x = centerX + override.dx;
          y = centerY + override.dy;
          anchor = override.anchor || "middle";
        }

        const text = doc.createElementNS(ns, "text");
        text.classList.add("m-service-area-map__state-label");
        if (override || tinyState) {
          text.classList.add("is-callout");
        }
        text.dataset.stateId = stateId;
        text.setAttribute("aria-hidden", "true");
        text.setAttribute("x", x.toFixed(2));
        text.setAttribute("y", y.toFixed(2));
        text.setAttribute("text-anchor", anchor);
        text.setAttribute("dominant-baseline", "middle");
        text.textContent = meta.abbr.toUpperCase();

        if (override) {
          const line = doc.createElementNS(ns, "line");
          line.classList.add("m-service-area-map__state-leader");
          line.dataset.stateId = stateId;
          line.setAttribute("aria-hidden", "true");
          line.setAttribute("x1", centerX.toFixed(2));
          line.setAttribute("y1", centerY.toFixed(2));
          line.setAttribute("x2", x.toFixed(2));
          line.setAttribute("y2", y.toFixed(2));
          labelLayer.appendChild(line);
          this.stateLeaderLines.set(stateId, line);
        }

        labelLayer.appendChild(text);
        this.stateLabels.set(stateId, text);
      });

      svg.appendChild(labelLayer);
    }

    selectState(stateId, options = {}) {
      if (!stateId) {
        this.selectOverview();
        return;
      }

      if (this.isNationwideMode()) {
        this.selectNationwideState(stateId);
        return;
      }

      const stateData = this.getStateData(stateId) || this.getFallbackState(stateId);
      this.activeState = stateId;
      this.activeCity = stateData.cities?.[0]?.id || null;

      this.updateMapSelection(stateId);
      this.revealStateInViewport(stateId);
      this.setOverviewButtonState(false);

      this.renderStateSummary(stateData);
      this.renderCityHead(
        `${stateData.name || "Featured"} cities`,
        "Choose a city to reveal its service focus and booking link."
      );
      this.renderCityPills(stateData);

      if (stateData.cities?.length) {
        this.selectCity(this.activeCity);
        this.emptyEl.hidden = true;
      } else {
        this.cityCardEl.hidden = true;
        this.emptyEl.textContent = `No featured cities are configured for ${stateData.name || "this state"} yet. Keep the U.S. overview visible and route guests into your nationwide inquiry flow instead.`;
        this.emptyEl.hidden = false;
      }
    }

    selectNationwideState(stateId) {
      this.activeState = null;
      this.activeCity = null;

      this.updateMapSelection(null);
      this.revealStateInViewport(stateId);
      this.setOverviewButtonState(true);
      this.renderStateSummary(this.getOverviewState());
      this.renderCityHead(
        "Nationwide booking",
        "Hibachi Yume serves all 50 states. Use the same reservation form for every location."
      );

      if (this.cityPillsEl) {
        this.cityPillsEl.innerHTML = "";
      }
      if (this.cityZoneEl) {
        this.cityZoneEl.classList.add("is-empty");
      }
      if (this.cityCardEl) {
        this.cityCardEl.hidden = true;
      }
      if (this.emptyEl) {
        this.emptyEl.textContent = "All U.S. locations use the same booking flow. Select Book Now to request your event.";
        this.emptyEl.hidden = false;
      }
    }

    selectOverview() {
      this.activeState = null;
      this.activeCity = null;

      this.updateMapSelection(null);
      this.resetMapViewport();
      this.setOverviewButtonState(true);
      this.renderStateSummary(this.getOverviewState());
      this.renderCityHead(
        this.isNationwideMode() ? "Nationwide booking" : this.defaultCityContent.title,
        this.isNationwideMode()
          ? "Hibachi Yume serves all 50 states. Use the same reservation form for every location."
          : "Select a featured state on the map to reveal city-level service coverage and booking links."
      );

      if (this.cityPillsEl) {
        this.cityPillsEl.innerHTML = "";
      }
      if (this.cityZoneEl) {
        this.cityZoneEl.classList.add("is-empty");
      }
      if (this.cityCardEl) {
        this.cityCardEl.hidden = true;
      }
      if (this.emptyEl) {
        this.emptyEl.textContent = this.isNationwideMode()
          ? "All U.S. locations use the same booking flow. Select Book Now to request your event."
          : "Select a featured state on the map to reveal city-level service coverage and booking links.";
        this.emptyEl.hidden = false;
      }
    }

    updateMapSelection(stateId) {
      this.stateNodes.forEach((node, id) => {
        const isActive = id === stateId;
        node.classList.toggle("is-active", isActive);
        node.setAttribute("aria-pressed", isActive ? "true" : "false");
      });

      this.stateLabels.forEach((label, id) => {
        label.classList.toggle("is-active", id === stateId);
      });

      this.stateLeaderLines.forEach((line, id) => {
        line.classList.toggle("is-active", id === stateId);
      });
    }

    setOverviewButtonState(isActive) {
      this.resetButtons.forEach((button) => {
        button.classList.toggle("is-active", isActive);
        button.setAttribute("aria-pressed", isActive ? "true" : "false");
      });
    }

    renderStateSummary(stateData) {
      if (this.badgeEl) {
        this.badgeEl.textContent = stateData.badge || "";
        this.badgeEl.hidden = !stateData.badge;
        this.applyAccentStyle(this.badgeEl, stateData.badgeBgColor, stateData.badgeTextColor);
      }

      if (this.titleEl) {
        this.titleEl.textContent = stateData.name || this.dataset.nationalHeading || "Nationwide hibachi inquiries";
      }

      if (this.labelEl) {
        this.labelEl.textContent = stateData.label || "";
      }

      if (this.descriptionEl) {
        this.descriptionEl.innerHTML = stateData.descriptionHtml || stateData.description || "";
      }

      if (this.actionsEl) {
        const buttons = [];
        if (stateData.ctaLabel && stateData.ctaUrl) {
          buttons.push(
            `<a href="${escapeHtml(stateData.ctaUrl)}" class="m-button m-button--primary">${escapeHtml(stateData.ctaLabel)}</a>`
          );
        }
        if (stateData.secondaryCtaLabel && stateData.secondaryCtaUrl) {
          buttons.push(
            `<a href="${escapeHtml(stateData.secondaryCtaUrl)}" class="m-button m-button--secondary">${escapeHtml(stateData.secondaryCtaLabel)}</a>`
          );
        }
        if (stateData.emailCtaLabel && stateData.emailCtaUrl) {
          buttons.push(
            `<a href="${escapeHtml(stateData.emailCtaUrl)}" class="m-button m-button--secondary">${escapeHtml(stateData.emailCtaLabel)}</a>`
          );
        }
        this.actionsEl.innerHTML = buttons.join("");
      }
    }

    renderCityHead(title, subtext) {
      if (this.cityTitleEl) {
        this.cityTitleEl.textContent = title || this.defaultCityContent.title;
      }
      if (this.citySubtextEl) {
        this.citySubtextEl.textContent = subtext || this.defaultCityContent.subtext;
      }
    }

    renderCityPills(stateData) {
      if (!this.cityPillsEl) return;

      if (!stateData.cities?.length) {
        this.cityPillsEl.innerHTML = "";
        this.cityZoneEl?.classList.add("is-empty");
        return;
      }

      this.cityZoneEl?.classList.remove("is-empty");
      this.cityPillsEl.innerHTML = stateData.cities
        .map(
          (city) => `
            <button
              type="button"
              class="m-service-area-map__city-pill${city.id === this.activeCity ? " is-active" : ""}"
              data-city-id="${escapeHtml(city.id)}"
              style="${escapeHtml(this.getAccentStyleValue(city.accentBgColor, city.accentTextColor))}"
            >
              ${escapeHtml(city.name)}
            </button>
          `
        )
        .join("");
    }

    selectCity(cityId) {
      if (!this.activeState) return;

      const stateData = this.getStateData(this.activeState) || this.getFallbackState(this.activeState);
      const city = stateData?.cities?.find((item) => item.id === cityId);
      if (!city) return;

      this.activeCity = cityId;

      this.querySelectorAll("[data-city-id]").forEach((button) => {
        button.classList.toggle("is-active", button.dataset.cityId === cityId);
      });

      if (this.cityBadgeEl) {
        this.cityBadgeEl.textContent = city.badge || stateData.badge || "";
        this.cityBadgeEl.hidden = !this.cityBadgeEl.textContent;
        this.applyAccentStyle(
          this.cityBadgeEl,
          city.accentBgColor || stateData.badgeBgColor,
          city.accentTextColor || stateData.badgeTextColor
        );
      }
      if (this.cityNameEl) this.cityNameEl.textContent = city.name || "";
      if (this.cityStateEl) this.cityStateEl.textContent = stateData.code ? `${stateData.code}` : "";
      if (this.cityServiceLabelEl) this.cityServiceLabelEl.textContent = city.serviceLabel || "";
      if (this.cityDescriptionEl) this.cityDescriptionEl.innerHTML = city.description || "";
      if (this.cityMetaEl) {
        this.cityMetaEl.innerHTML = [city.eventFocus, city.travelNote]
          .filter(Boolean)
          .map((item) => `<span class="m-service-area-map__meta-pill">${escapeHtml(item)}</span>`)
          .join("");
      }
      if (this.cityActionsEl) {
        const actions = [];
        if (city.ctaLabel && city.url) {
          actions.push(
            `<a href="${escapeHtml(city.url)}" class="m-button m-button--primary">${escapeHtml(city.ctaLabel)}</a>`
          );
        }
        if (city.secondaryLabel && city.secondaryUrl) {
          actions.push(
            `<a href="${escapeHtml(city.secondaryUrl)}" class="m-button m-button--link">${escapeHtml(city.secondaryLabel)}</a>`
          );
        }
        this.cityActionsEl.innerHTML = actions.join("");
      }
      this.cityCardEl.hidden = false;
    }

    setStatus(message) {
      if (!this.statusEl) return;
      this.statusEl.textContent = message;
      this.statusEl.hidden = !message;
    }

    getAccentStyleValue(bgColor, textColor) {
      const declarations = [];
      if (bgColor) declarations.push(`--m-service-area-accent-bg:${bgColor}`);
      if (textColor) declarations.push(`--m-service-area-accent-text:${textColor}`);
      return declarations.join(";");
    }

    applyAccentStyle(element, bgColor, textColor) {
      if (!element) return;

      if (bgColor) {
        element.style.setProperty("--m-service-area-accent-bg", bgColor);
      } else {
        element.style.removeProperty("--m-service-area-accent-bg");
      }

      if (textColor) {
        element.style.setProperty("--m-service-area-accent-text", textColor);
      } else {
        element.style.removeProperty("--m-service-area-accent-text");
      }
    }

    revealStateInViewport(stateId) {
      if (!window.matchMedia("(max-width: 767px)").matches) return;
      if (!this.svgStageEl || !stateId) return;

      const stateNode = this.stateNodes.get(stateId);
      if (!stateNode) return;

      window.requestAnimationFrame(() => {
        const stageRect = this.svgStageEl.getBoundingClientRect();
        const stateRect = stateNode.getBoundingClientRect();
        const maxLeft = this.svgStageEl.scrollWidth - this.svgStageEl.clientWidth;
        const maxTop = this.svgStageEl.scrollHeight - this.svgStageEl.clientHeight;

        const nextLeft =
          this.svgStageEl.scrollLeft +
          (stateRect.left - stageRect.left) -
          (this.svgStageEl.clientWidth / 2 - stateRect.width / 2);
        const nextTop =
          this.svgStageEl.scrollTop +
          (stateRect.top - stageRect.top) -
          (this.svgStageEl.clientHeight / 2 - stateRect.height / 2);

        this.svgStageEl.scrollTo({
          left: Math.max(0, Math.min(maxLeft, nextLeft)),
          top: Math.max(0, Math.min(maxTop, nextTop)),
          behavior: "smooth"
        });
      });
    }

    resetMapViewport() {
      if (!window.matchMedia("(max-width: 767px)").matches) return;
      if (!this.svgStageEl) return;

      this.svgStageEl.scrollTo({
        left: 0,
        top: 0,
        behavior: "smooth"
      });
    }

    updateMobileSwipeHint() {
      this.updateSwipeHint();
    }

    updateSwipeHint() {
      if (!this.mobileHintEl || !this.svgStageEl) return;

      const isMobile = window.matchMedia("(max-width: 767px)").matches;
      const shouldUseExpandedHint = this.isExpanded && !isMobile;
      const hasOverflow =
        this.svgStageEl.scrollWidth > this.svgStageEl.clientWidth + 12 ||
        this.svgStageEl.scrollHeight > this.svgStageEl.clientHeight + 12;
      const hasScrolled = this.svgStageEl.scrollLeft > 8 || this.svgStageEl.scrollTop > 8;
      const shouldShowHint = hasOverflow && (isMobile || this.isExpanded);
      const shouldHide = !shouldShowHint || hasScrolled;

      this.mobileHintEl.textContent = shouldUseExpandedHint
        ? "Drag the expanded map to explore more states"
        : "Swipe the map to explore more states";
      this.mobileHintEl.hidden = !shouldShowHint;
      this.mobileHintEl.classList.toggle("is-hidden", shouldHide);
      this.svgStageEl.classList.toggle("has-map-overflow", shouldShowHint);
    }

    canDragMap() {
      if (!this.svgStageEl) return false;

      const hasOverflow =
        this.svgStageEl.scrollWidth > this.svgStageEl.clientWidth + 12 ||
        this.svgStageEl.scrollHeight > this.svgStageEl.clientHeight + 12;
      return hasOverflow && (this.isExpanded || window.matchMedia("(max-width: 767px)").matches);
    }

    toggleExpanded(force) {
      const nextState = typeof force === "boolean" ? force : !this.isExpanded;
      this.isExpanded = nextState;

      this.classList.toggle("is-expanded", nextState);
      document.body?.classList.toggle("m-service-area-map-expanded", nextState);

      this.expandButtons.forEach((button) => {
        button.setAttribute("aria-expanded", nextState ? "true" : "false");
        button.classList.toggle("is-active", nextState);
      });
      this.closeExpandButtons.forEach((button) => {
        button.classList.toggle("is-active", nextState);
      });

      if (this.expandBackdropEl) {
        this.expandBackdropEl.setAttribute("aria-hidden", nextState ? "false" : "true");
      }

      this.updateSwipeHint();
    }
  }

  customElements.define("m-service-area-map", MServiceAreaMap);
}
